import $ from 'jquery'
import { register } from '@shopify/theme-sections'
import {iframeResize} from 'iframe-resizer'

export default register(`template-article`, {
  onLoad() {
    const { container } = this
    this.video = container.querySelector(`video`)
    this.playButton = container.querySelector(`[data-video-play]`)
    this.fromVisible = container.querySelector(`#articleForm`)

    if (!$(`body`).hasClass(`template-article`)) {
      return false
    }

    setTimeout(() => {
      this.fromVisible.classList.add(`visible`)
    }, 800)

    if (this.video) {
      this.video.addEventListener(
        `click`,
        (event) => {
          if (this.video.paused) {
            return this.playVideo()
          }
          return this.pauseVideo()
        }
      )
    }
    iframeResize(
        {
          log: false,
          resizedCallback: function(messageData){
            const height = messageData.height
            document.getElementById(`articleForm`).style.height = height+ `px`
          }
        }, `.iframe-form`)
  },
  pauseVideo() {
    this.video.pause()
    this.playButton.classList.remove(`hide`)
  },
  playVideo() {
    this.video.play()
    this.playButton.classList.add(`hide`)
  },
  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {}
})
